import React, { useState, useEffect } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import AuctionItems from "./AuctionItems";
import Productforsale from "./Productforsale";
import RentalProducts from "./RentalProducts";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import CompletedBXPListing from "./CompletedBXPListing";

export default function AllActiveOrders({ postcounts }) {
  const path = "Assets/scss/myorders.module.scss";
  const [activeTab, setActiveTab] = useState("Auctionitems");
  const { urlstate, setReceivedOrderActiveroute } = useRouteBaseStateContext();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setReceivedOrderActiveroute(tab);
  };

  useEffect(() => {
    if (urlstate?.receivedorderrouteactive) {
      setActiveTab(urlstate?.receivedorderrouteactive || "Auctionitems");
    } else {
      setActiveTab("Auctionitems");
    }
  }, [urlstate, urlstate?.receivedorderrouteactive]);

  return (
    <div className="order-tabs completed-tab-sec">
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <a

            className={`nav-link ${activeTab == "CompletedBXPListing" ? "active" : ""}`}
            onClick={() => handleTabChange("CompletedBXPListing")}
          >
            One Time Services (OTS) ({postcounts?.bxp || 0})
          </a>
        </li>
        <li className="nav-item">
          <a

            className={`nav-link ${activeTab == "Productforsale" ? "active" : ""}`}
            onClick={() => handleTabChange("Productforsale")}
          >
            Buy & Sell with Market (BSM) ({postcounts?.sale || 0})
          </a>
        </li>
        <li className="nav-item">
          <a

            className={`nav-link ${activeTab == "Rentalproducts" ? "active" : ""}`}
            onClick={() => handleTabChange("Rentalproducts")}
          >
            Turn Assets to Income (TAI)
            ({postcounts?.rental || 0})
          </a>
        </li>
        <li className="nav-item">
          <a

            className={`nav-link ${activeTab == "Auctionitems" ? "active" : ""}`}
            onClick={() => handleTabChange("Auctionitems")}
          >
            Buy & Sell with Auction (BSA) items ({postcounts?.auction || 0})
          </a>
        </li>
      </ul>
      <div className="tab-content">
        {activeTab == "Auctionitems" && <AuctionItems />}
        {activeTab == "Productforsale" && <Productforsale />}
        {activeTab == "Rentalproducts" && <RentalProducts />}
        {activeTab == "CompletedBXPListing" && <CompletedBXPListing />}
      </div>
    </div>
  );
}
